/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detect_Shot_ChangesInputs */

const en_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Shot Changes`)
};

const fr_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détecter les changements de plan`)
};

const de_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schusswechsel erkennen`)
};

const it_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva i cambiamenti di tiro`)
};

const ru_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение изменений в выстреле`)
};

const es_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar cambios en la toma`)
};

const zh_cn2_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测投篮变化`)
};

const ja_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更を検出する`)
};

const hi_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तनों का पता लगाएं`)
};

const pt_pt2_detect_shot_changes = /** @type {(inputs: Detect_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar mudanças de tiro`)
};

/**
* | output |
* | --- |
* | "Detect Shot Changes" |
*
* @param {Detect_Shot_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const detect_shot_changes = /** @type {((inputs?: Detect_Shot_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detect_Shot_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_detect_shot_changes(inputs)
	if (locale === "de") return de_detect_shot_changes(inputs)
	if (locale === "it") return it_detect_shot_changes(inputs)
	if (locale === "ru") return ru_detect_shot_changes(inputs)
	if (locale === "es") return es_detect_shot_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_detect_shot_changes(inputs)
	if (locale === "ja") return ja_detect_shot_changes(inputs)
	if (locale === "hi") return hi_detect_shot_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_detect_shot_changes(inputs)
	return en_detect_shot_changes(inputs)
});